import { useState, useEffect } from 'react';
import { VStack, Text, Heading, Box, HStack, Button } from 'native-base';
import { ActivityIndicator, Dimensions } from 'react-native';
import { useTransition, animated, config } from 'react-spring';

// Assets
import { theme } from '@breakroom-nx/assets';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  useAppSelector,
  getVibe,
  clearVibe,
  closeModal,
  openModal,
  useAppDispatch,
  useFindRoomsWithVibeQuery,
} from '@breakroom-nx/redux';

// Components
import {
  ModalWrapper,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
  Vibe,
} from '../../';

const SliderWidth = Dimensions.get('window').width;

export const Search = () => {
  const [searchState, setSearchState] = useState(
    'Finding the perfect room with your vibe...'
  );
  const [showResults, setShowResults] = useState(false); // NEW

  const vibe = useAppSelector(getVibe);
  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();

  //! APIs
  const { data: room, isLoading } = useFindRoomsWithVibeQuery({
    vibe: vibe.text,
  });

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!isLoading) {
      timeout = setTimeout(() => {
        setShowResults(true);
        if (room && room.length < 1) {
          setSearchState('No Rooms Found');
        } else {
          setSearchState('Room found! Joining room.');
        }
      }, 3000); // 1 second delay
    } else {
      setShowResults(false);
      setSearchState('Finding the perfect room with your vibe...');
    }
    return () => clearTimeout(timeout);
  }, [isLoading, room]);

  useEffect(() => {
    // console.log(`Vibes: ${vibes}`);
  }, []);

  const [index, set] = useState(0);
  const transitions = useTransition(index, {
    key: index,
    from: { opacity: 0, transform: 'translateX(100%)' },
    enter: { opacity: 1, transform: 'translateX(0%)' },
    leave: { opacity: 0, transform: 'translateX(-100%)' },
    config: { mass: 10, tension: 150, friction: 100 },
    onRest: (_a, _b, item) => {
      if (index === item) {
        set((state) => (state + 1) % 1);
      }
    },
    exitBeforeEnter: true,
  });

  return (
    <ModalWrapper disabled>
      <VStack
        bg={'surface.100'}
        p={7}
        rounded={'2xl'}
        width={'full'}
        space={10}
      >
        <Heading fontSize={30} lineHeight={34} textAlign={'center'}>
          {searchState}
        </Heading>
        {!showResults ? (
          <VStack space={5}>
            {/* Display Vibe Data */}
            {transitions((style, i) => (
              <animated.div
                style={{
                  width: 'full',
                  ...style,
                }}
              >
                <VStack alignItems={'center'}>
                  <Vibe text={vibe.text} icon={vibe.icon} />
                </VStack>
              </animated.div>
            ))}
            <ActivityIndicator
              animating={true}
              color={theme.colors.surface[400]}
            />
          </VStack>
        ) : !room || room.length === 0 ? (
          <VStack space={10}>
            <Text
              textAlign={'center'}
              fontSize={16}
              lineHeight={21}
              fontWeight={200}
              color={'surface.700'}
            >
              {`No rooms matched your exact vibe. We can show you similar rooms, or you can be the first to create a room with this exact vibe! We will let you know when users join.`}
            </Text>
            <VStack space={5}>
              <PrimaryButton
                text="Show Me Similar Rooms"
                onPress={() => {
                  dispatch(closeModal());
                  // Find similar rooms and dispatch it to the globe.
                }}
              />
              <SecondaryButton
                text="Create Room"
                onPress={() => {
                  dispatch(closeModal());
                  dispatch(openModal({ modalType: 'CreateChat' }));
                }}
              />
              <TertiaryButton
                text="Cancel"
                color="surface.500"
                onPress={() => {
                  appDispatch(clearVibe());
                  dispatch(closeModal());
                }}
              />
            </VStack>
          </VStack>
        ) : null}
      </VStack>
    </ModalWrapper>
  );
};
